<template>
    <div class="cates-box">
        <el-select v-model="dwgc" clearable filterable placeholder="单位工程">
            <el-option :value="item" v-for="(item,index) in dwgcs" :key="index"></el-option>
        </el-select>
        <el-cascader :show-all-levels="false" v-model="dwfbs" :options="zdws"
            :props="{  value:'title',label:'title' ,checkStrictly: true}" clearable placeholder="子单位/分部"
            :disabled="disabled" v-if="zdws.length">
        </el-cascader>
        <el-cascader :show-all-levels="false" v-model="fxs" :options="cates"
            :props="{  value:'title',label:'title',checkStrictly: true }" clearable placeholder="分部/子分部/分项"
            :disabled="disabled" v-else>
        </el-cascader>
    </div>
</template>
<script>
    export default {
        props: {
            info: {},
            disabled: {},
            is_form: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                dwgc: '',
                dwfbs: [],
                fxs: [],
                cates: [],
                zdws0: [
                    {
                        title: '道路', children: [
                            { title: '路基' },
                            { title: '基层' },
                            { title: '面层' },
                            { title: '广场与停车场' },
                            { title: '人行道' },
                            { title: '人形地道' },
                            { title: '挡土墙' },
                            { title: '附属构筑物' },
                        ]
                    },
                    {
                        title: '边坡', children: [
                            { title: '土石方' },
                            { title: '挡土墙' },
                            { title: '支护' },
                        ]
                    }
                ],
                zdws1: [
                    {
                        title: '附属建筑', children: [
                            { title: '车棚' },
                            { title: '围墙' },
                            { title: '大门' },
                            { title: '挡土墙' },
                        ]
                    },
                    {
                        title: '室外环境', children: [
                            { title: '建筑小品' },
                            { title: '亭台' },
                            { title: '水景' },
                            { title: '连廊' },
                            { title: '花坛' },
                            { title: '场坪绿化' },
                            { title: '景观桥' },
                        ]
                    },
                ]
            }
        },
        computed: {
            zdws() {
                let res = [];
                if (this.dwgc == '室外设施') {
                    res = this.zdws0;
                }
                else if (this.dwgc == '附属建筑及室外环境') {
                    res = this.zdws1;
                }
                else {
                    res = [];
                }
                return res || [];
            },
            dwgcs() {
                let res = [];
                ((this.vuex_admin.pro || {}).items || []).map(item => {
                    res.push(item.title);
                });
                res.push('室外设施', '附属建筑及室外环境');
                return res || [];
            },
            change_str() {
                let res = `${this.dwgc}_${this.dwfbs.join('_')}_${this.fxs.join('_')}`;
                return res || '';
            }
        },
        watch: {
            info(val) {
                this.dwgc = val.dwgc;
                this.dwfbs = [];
                this.fxs = [];
                this.dwfbs.push(val.zdw, val.fb);
                this.fxs.push(val.fb, val.zfb, val.fx);
            },
            change_str(val) {
                let res = {};
                if (this.zdws.length) {
                    res.zdw = this.dwfbs[0];
                    res.fb = this.dwfbs[1];
                } else {
                    res.fb = this.fxs[0];
                    res.zfb = this.fxs[1];
                    res.fx = this.fxs[2];
                }
                this.$emit('change', {
                    ...res,
                    dwgc: this.dwgc
                });
            }
        },
        created() {
            this._cates();
        },
        methods: {
            _cates() {
                this.$http.post('cate/tree').then(res => {
                    this.cates = res.data;
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "index.scss";
</style>